var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPartner2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .hand-1 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .hand-1, .hand-2 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "hand-1",
    x: 7.76,
    y: 12.67,
    width: 6.89,
    height: 11.85,
    transform: "translate(12.55 -3.07) rotate(34.64)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hand-1",
    d: "m14.47,28.92s.01.01.02.02l.27-.29-.09.1c-.06.06-.12.12-.19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-1",
    d: "m19.65,33.27l-.41.45s.06.05.09.08c.07-.19.18-.37.32-.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "hand-1",
    points: "19.78 33.13 19.8 33.11 19.8 33.11 19.78 33.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-1",
    d: "m38.11,29.12s-2.79-2.2-6.78-5.18c-1.42-1.06-2.86.91-4.85-3.35-.27.07-.52.24-.67.49l-2.21,3.55c-.39.63-1.11.94-1.8.85-.25-.03-.49-.12-.72-.26-.86-.53-1.13-1.67-.59-2.53l2.21-3.55c.11-.17.22-.33.35-.49-2.05-1.01-4.18-1.78-6.28-2.04l-5.41,7.83c.14.3.3.61.47.92.17.29.36.59.56.9.63-.62,1.63-.66,2.3-.06l.02.02c.68.62.74,1.68.12,2.36l.25-.28c.62-.68,1.68-.73,2.36-.11l.02.02c.68.62.73,1.68.11,2.36l-.75.83,1.5-1.65c.62-.68,1.67-.74,2.36-.12l.02.02c.68.62.74,1.67.12,2.36l-1,1.1c.62-.68,1.67-.74,2.36-.12l.02.02c.68.62.74,1.67.12,2.36l-.15.17c-.13.15-.29.26-.46.35.48.41.76.64.76.64l1.89,1.3c1.05.73,2.49.46,3.22-.59.45-.65.24-1.48-.41-1.93l-2.57-1.87,3.4,2.35c1.05.73,2.49.46,3.22-.59.45-.65.25-1.49-.4-1.94l-3.04-2.16,4.59,3.15c.65.45,1.55.29,2-.37l.5-.72c.45-.65.24-1.48-.41-1.93l-3.49-2.47,5.04,3.45c.65.45,1.55.29,2-.37l.5-.72c.45-.65.29-1.55-.37-2Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hand-1",
    d: "m31.72,17.08l-4.79-.19c-1.71-.07-3.34.8-4.24,2.25l-2.21,3.55c-.53.86-.27,1.99.59,2.53.23.14.47.23.72.26.69.09,1.41-.22,1.8-.85l2.21-3.55c.15-.25.4-.42.67-.49,1.99,4.26,3.43,2.29,4.85,3.35,2.12,1.58,3.89,2.93,5.09,3.86.45-.44.87-.88,1.22-1.3.22-.27.43-.55.62-.82l-.24-.52-3.78-8.1-2.51.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hand-1",
    x: 35.93,
    y: 14.01,
    width: 6.89,
    height: 11.85,
    transform: "translate(83.48 21.33) rotate(154.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hand-1",
    x: 16.98,
    y: 28.87,
    width: 3.37,
    height: 5.97,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(11.1 67.98) rotate(-137.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hand-1",
    x: 14.12,
    y: 27.57,
    width: 3.37,
    height: 4.86,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(7.35 62.83) rotate(-137.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hand-1",
    x: 11.8,
    y: 25.75,
    width: 3.37,
    height: 3.57,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(4.98 56.99) rotate(-137.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hand-1",
    x: 19.29,
    y: 32.54,
    width: 3.37,
    height: 3.57,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(13.45 73.83) rotate(-137.8)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "hand-2",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartner2);
export default __webpack_public_path__ + "static/media/icon-partner2.2996cac642bda654ee96d061063c3020.svg";
export { ForwardRef as ReactComponent };